import { Navigate, useParams } from 'react-router-dom';

/** Redirect old check-in nested statistics URLs to insights query params. */
export default function StatisticsLegacyRedirect() {
  const { year, competition } = useParams<{ year: string; competition: string }>();
  if (year && competition) {
    return (
      <Navigate
        to={`/dashboard/insights?year=${year}&competition=${competition}`}
        replace
      />
    );
  }
  if (year) {
    return <Navigate to={`/dashboard/insights?year=${year}`} replace />;
  }
  return <Navigate to="/dashboard/insights" replace />;
}
